<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.2 0C7.64183 0 8 0.358172 8 0.8C8 1.01217 7.91571 1.21566 7.76569 1.36569C7.61566 1.51571 7.41217 1.6 7.2 1.6H2.4C1.95817 1.6 1.6 1.95817 1.6 2.4V13.6C1.6 14.0418 1.95817 14.4 2.4 14.4H13.6C14.0418 14.4 14.4 14.0418 14.4 13.6V8.8C14.4 8.35817 14.7582 8 15.2 8C15.6418 8 16 8.35817 16 8.8V13.6C16 14.9255 14.9255 16 13.6 16H2.4C1.07452 16 0 14.9255 0 13.6V2.4C0 1.07452 1.07452 0 2.4 0H7.2ZM8.3565 9.29572C8.13141 9.52025 7.82642 9.64627 7.5085 9.64612C7.02312 9.64602 6.5856 9.35353 6.39998 8.90505C6.21435 8.45657 6.31717 7.94043 6.6605 7.59732L11.8365 2.43252C11.8743 2.39508 11.8956 2.34412 11.8957 2.29092C11.8954 2.23793 11.8744 2.18715 11.8373 2.14932L10.4285 0.741324C10.3144 0.626838 10.2804 0.454909 10.3423 0.305601C10.4043 0.156292 10.55 0.0589583 10.7117 0.0589241H15.5117C15.7326 0.0589241 15.9117 0.23801 15.9117 0.458924V5.25892C15.9117 5.42079 15.8141 5.56669 15.6645 5.62852C15.616 5.64834 15.5641 5.65866 15.5117 5.65892C15.4054 5.6589 15.3035 5.61659 15.2285 5.54132L13.8133 4.12932C13.7759 4.09176 13.7251 4.07063 13.6721 4.07063C13.6191 4.07063 13.5683 4.09176 13.5309 4.12932L8.3565 9.29572Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  name: "bt-new-tab",
  props: {
    color: {
      type: String,
      default: "var(--text-color-primary)",
    },
  },
};
</script>
